import { css } from '@emotion/react';
import styled from '@emotion/styled';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 24px;
`;

export const Title = styled.h1`
  ${({ theme }) => css`
    ${theme.fontStyle.title.section24_bold}
    color: ${theme.content.content_light_1};
  `}
`;
